import React, { Component } from 'react'
import { compose, graphql, Query } from 'react-apollo'
import { Form, Field } from 'react-final-form'
import moment from 'moment'
import Datetime from 'react-datetime'

// graphql
import campagne from 'graphql/queries/campagne'
import offerte from 'graphql/queries/offerte'
import createAzione from 'graphql/mutations/createAzione'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'
import TextField from 'components/TextField/TextField'
import AutocompleteField from 'components/AutocompleteField/AutocompleteField'
import FormControl from 'material-ui/Form/FormControl'
import InputLabel from 'material-ui/Input/InputLabel'
import Button from 'material-ui/Button'

// material icons
import PhoneIcon from 'material-ui-icons/Phone'
import EmailIcon from 'material-ui-icons/Email'

// styles
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx'
import './Dati.css'

const WhatsappIcon = () => (
  <svg viewBox="0 0 24 24" title="WhatsApp">
    <path
      fill="currentColor"
      d="M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8z"
    ></path>
  </svg>
)

class FormCreaAzione extends Component {
  constructor(props) {
    super(props)

    this.state = {
      campagneSearchQuery: '',
      offerteSearchQuery: '',
      initialValues: {
        tipoAzione: '1',
        campagnaId: null,
        offertaId: null,
        nonRisposto: false,
        appuntamentoOrigine:'',
        descrizione: '',
        dataOra: moment().toDate(),
      },
    }
  }

  handleChangeCampagneSearchQuery = (campagneSearchQuery) => {
    // console.log('q', campagneSearchQuery)
    this.setState({
      campagneSearchQuery,
    })
  }

  handleChangeOfferteSearchQuery = (offerteSearchQuery) => {
    // console.log('q', offerteSearchQuery)
    this.setState({
      offerteSearchQuery,
    })
  }

  onSubmit = (values) => {
    const valuesToSave = {
      clienteId: this.props.clienteId,
      dataOra: moment(values.dataOra).format('YYYY-MM-DD HH:mm'),
      tipoAzioneId: parseInt(values.tipoAzione, 10),
      campagnaId: values.campagnaId,
      offertaId: values.offertaId,
      descrizione: values.nonRisposto ? 'Non ha risposto' : values.descrizione,
      appuntamentoOrigine:values.appuntamentoOrigine,
      nonRisposto: values.nonRisposto,
    }

    this.props
      .createAzione({
        variables: {
          azione: valuesToSave,
        },
        refetchQueries: ['cliente'],
      })
      .then(({ data }) => {
        this.props.onSaved()
        //console.log(data)
      })
      .catch((error) => {
        console.log(error.message)
      })
  }

  isValidDate = (date) => {
    const momentDate = moment(date, 'YYYY-MM-DD HH:mm', true)
    return momentDate.isValid()
  }

  validate = (values) => {
    const errors = {}

    if (!values.nonRisposto && !values.descrizione) {
      errors.descrizione = 'Richiesto'
    }
    if (!values.dataOra || !this.isValidDate(values.dataOra)) {
      errors.dataOra = 'Richiesto'
    }
    

    return errors
  }

  render() {
    return (
      <div className="form-container">
        <h3>Nuova azione</h3>
        <Form
          onSubmit={this.onSubmit}
          initialValues={this.state.initialValues}
          validate={this.validate}
          render={({ handleSubmit, form, submitting, pristine, invalid, values }) => {
            return (
              <form
                onSubmit={(event) => {
                  handleSubmit(event)
                  form.reset()
                }}
              >
                {/* TIPO TELEFONATA */}
                <div>
                  <table>
                    <thead>
                      <tr>
                        <th colSpan={3}>Uscita</th>
                        <th style={{ width: 40 }}></th>
                        <th colSpan={3}>Ingresso</th>
                      </tr>
                      <tr>
                        <th style={{ color: '#e91e63', width: 32 }}>
                          <PhoneIcon />
                        </th>
                        <th style={{ color: '#4fce5d', width: 32 }}>
                          <div style={{ width: 24 }}>
                            <WhatsappIcon />
                          </div>
                        </th>
                        <th style={{ color: '#f5a206', width: 32 }}>
                          <EmailIcon />
                        </th>
                        <th></th>
                        <th style={{ color: '#e91e63', width: 32 }}>
                          <PhoneIcon />
                        </th>
                        <th style={{ color: '#4fce5d', width: 32 }}>
                          <div style={{ width: 24 }}>
                            <WhatsappIcon />
                          </div>
                        </th>
                        <th style={{ color: '#f5a206', width: 32 }}>
                          <EmailIcon />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <Field name="tipoAzione" component="input" type="radio" value="3" />
                        </td>
                        <td>
                          <Field name="tipoAzione" component="input" type="radio" value="14" />
                        </td>
                        <td>
                          <Field name="tipoAzione" component="input" type="radio" value="5" />
                        </td>
                        <td></td>
                        <td>
                          <Field name="tipoAzione" component="input" type="radio" value="2" />
                        </td>
                        <td>
                          <Field name="tipoAzione" component="input" type="radio" value="13" />
                        </td>
                        <td>
                          <Field name="tipoAzione" component="input" type="radio" value="4" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* NON RISPOSTO */}
                {/* {(values.tipoAzione === '3' ||
                  values.tipoAzione === '5' ||
                values.tipoAzione === '14') && ( */}
                {values.tipoAzione === '3' && (
                  <label style={{ display: 'block', margin: '25px 0 8px', color: '#6a7168' }}>
                    <Field
                      name="nonRisposto"
                      component="input"
                      type="checkbox"
                      // value={values.nonRisposto}
                    />
                    Non ha risposto
                  </label>
                )}

                {/* CAMPAGNA */}
                {(values.tipoAzione === '2' ||
                  values.tipoAzione === '4' ||
                  values.tipoAzione === '13') && (
                  <Query
                    query={campagne}
                    variables={{
                      limit: 4,
                      orderBy: ['nome_ASC'],
                      where: {
                        OR: [
                          {
                            nome_contains: this.state.campagneSearchQuery || 'az1az1az1az1az1az1',
                          },
                          { id: values.campagnaId || null },
                        ],
                      },
                    }}
                  >
                    {({ loading, error, data }) => {
                      return (
                        <Field
                          name="campagnaId"
                          label="Provenienza"
                          margin="normal"
                          fullWidth
                          component={TextField}
                          placeholder=""
                          InputProps={{
                            inputComponent: AutocompleteField,
                            inputProps: {
                              simpleValue: true,
                              options:
                                data && data.campagne
                                  ? data.campagne.nodes.map((campagna) => ({
                                      value: campagna.id,
                                      label: campagna.nome,
                                    }))
                                  : [],
                              onInputChange: this.handleChangeCampagneSearchQuery,
                            },
                          }}
                        />
                      )
                    }}
                  </Query>
                )}

                {/* OFFERTA */}
                {(values.tipoAzione === '2' ||
                  values.tipoAzione === '4' ||
                  values.tipoAzione === '13') && (
                  <Query
                    query={offerte}
                    variables={{
                      limit: 4,
                      orderBy: ['nome_ASC'],
                      where: {
                        OR: [
                          {
                            nome_contains: this.state.offerteSearchQuery || 'az1az1az1az1az1az1',
                          },
                          { id: values.offertaId || null },
                        ],
                      },
                    }}
                  >
                    {({ loading, error, data }) => {
                      return (
                        <Field
                          name="offertaId"
                          label="Offerta"
                          margin="normal"
                          fullWidth
                          component={TextField}
                          placeholder=""
                          InputProps={{
                            inputComponent: AutocompleteField,
                            inputProps: {
                              simpleValue: true,
                              options:
                                data && data.offerte
                                  ? data.offerte.nodes.map((offerta) => ({
                                      value: offerta.id,
                                      label: offerta.nome,
                                    }))
                                  : [],
                              onInputChange: this.handleChangeOfferteSearchQuery,
                            },
                          }}
                        />
                      )
                    }}
                  </Query>
                )}

                {/* DESCRIZIONE */}
                {!(values.tipoAzione === '3' && values.nonRisposto) && (
                  <Field
                    name="descrizione"
                    label="Descrizione"
                    type="text"
                    margin="normal"
                    fullWidth
                    multiline
                    rows="4"
                    component={TextField}
                  />
                )}

                {/* DATA ORA */}
                <div>
                  <br />
                  <InputLabel>Data e ora</InputLabel>
                  <br />
                  <FormControl fullWidth>
                    <Field
                      name="dataOra"
                      type="text"
                      margin="normal"
                      fullWidth
                      render={({ input, meta }) => (
                        <div>
                          <Datetime
                            {...input}
                            dateFormat="DD/MM/YYYY"
                            className="top-date-time-picker"
                          />
                          {meta.touched && meta.error && <span>{meta.error}</span>}
                        </div>
                      )}
                    />
                  </FormControl>
                </div>

                <Button
                  type="submit"
                  className="save-button"
                  disabled={invalid || submitting}
                  variant="raised"
                  color="primary"
                >
                  Salva
                </Button>
              </form>
            )
          }}
        />
      </div>
    )
  }
}

export default compose(
  graphql(createAzione, { name: 'createAzione' }),
  withStyles(extendedFormsStyle)
)(FormCreaAzione)



// WEBPACK FOOTER //
// ./src/views/App/Clienti/FormCreaAzione.jsx